/**
 * The Phieg CRM listing on the App Store — the one place its id lives.
 *
 * apps.apple.com links are universal links: tapped from the store app (the
 * WebView hands any external host to iOS) or from a Home Screen web app or
 * Safari, iOS opens the App Store app on the listing. The server's update
 * policy (/appUpdate/policy) may hand the app another URL, e.g. for a
 * region-specific listing; this is the default.
 */
export const APP_STORE_ID = "6811601335";
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;

/** Open the listing in the App Store (a new window, never this one). */
export function openAppStore(url = APP_STORE_URL) {
  try {
    window.open(url || APP_STORE_URL, "_blank", "noopener");
  } catch {
    /* a locked-down WebView; the link text still carries the URL */
  }
}
